export const environment = {
    production: false,
    isExternal: true,
    msalConfig: {
        auth: {
            clientId: 'aeda3780-bf4a-4493-af5f-33440fe8616d',
            authority: ""
        },
    },
    apiConfig: {
        scopes: ['openid profile offline_access aeda3780-bf4a-4493-af5f-33440fe8616d'],
        uri: 'https://pplfirstpreprod.onmicrosoft.com/aeda3780-bf4a-4493-af5f-33440fe8616d/app.user',
    },
    b2cPolicies: {
        names: {
            signUpSignIn: 'B2C_1_NG_Pre_Combined_SignIn',
            mfa: ''
        },
        authorities: {
            signUpSignIn: {
                authority:
                    'https://pplfirstpreprod.b2clogin.com/pplfirstpreprod.onmicrosoft.com/B2C_1_NG_Pre_Combined_SignIn',
            }, 
            mfa: {
                authority: ''
            }
        },
        authorityDomain: 'pplfirstpreprod.b2clogin.com',
    },
    apiUrl: 'https://ngenapiext-pre.pplfirst.com/external',
    mobileHealthUrl: 'https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings/',
    wotcUrl: 'https://sandbox.wotc.com/portal/public-partnerships-llc-sandbox/f8850?noStartDate=1',
    apimSubScriptionKey: '1e3f59f9796c48d092623f8f699192e7',
    restrictedMenus: ["process_codes", "service_codes", "participant_provider_rates", "authorizations", "timesheets"],
    mfaTimeOutSeconds: 600
};